import { render } from "./SeccionContacto.vue?vue&type=template&id=bb143862&scoped=true"
import script from "./SeccionContacto.vue?vue&type=script&lang=js"
export * from "./SeccionContacto.vue?vue&type=script&lang=js"

import "./SeccionContacto.vue?vue&type=style&index=0&id=bb143862&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_3fde62ecf17df48f63b2288f8ccd725b/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb143862"]])

export default __exports__